module.exports = __webpack_public_path__ + "img/img_brand4.877719b0.jpg";